"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFullyAssigned = exports.createPrototypeImport = void 0;
var Processor_1 = require("@microchip/scf-common/lib/Processor");
var Arrays_1 = require("@microchip/scf-device/lib/util/Arrays");
var AutoModuleHelpers_1 = require("./AutoModuleHelpers");
var createPrototypeImport = function (interfaceName, config) {
    var _a, _b;
    return (_b = (_a = config === null || config === void 0 ? void 0 : config.imports) === null || _a === void 0 ? void 0 : _a[interfaceName]) === null || _b === void 0 ? void 0 : _b.import;
};
exports.createPrototypeImport = createPrototypeImport;
var isFullyAssigned = function (imports, config) {
    var _a;
    //get peripheral interfaces.
    var interfaces = getHardwareInterfaces((_a = config === null || config === void 0 ? void 0 : config.peripherals) !== null && _a !== void 0 ? _a : []);
    for (var i = 0; i < interfaces.length; i++) {
        var imp = imports === null || imports === void 0 ? void 0 : imports[interfaces[i]];
        if (!imp || !(0, Processor_1.isAssigned)(imp)) {
            return false;
        }
    }
    return true;
};
exports.isFullyAssigned = isFullyAssigned;
//Assumes hardware import keys are the same as the interface IDs
var getHardwareInterfaces = function (peripherals) {
    var interfaces = (0, Arrays_1.map)(peripherals, function (peripheral) {
        var _a;
        return (_a = (0, AutoModuleHelpers_1.getFriendlyInterfaceId)(peripheral.interfaceId.name)) !== null && _a !== void 0 ? _a : "";
    });
    return interfaces;
};
//# sourceMappingURL=AutoModuleHardware.js.map